export const formFlowCopy = {
  accountInfo: {
    title: 'Tell us about yourself',
    formStep: 0,
    inputs: [
      {
        label: 'First name',
        type: 'text',
        placeholder: 'Enter First Name',
        error: 'First Name is required',
        name: 'first_name',
        hint: null,
        required: true,
      },
      {
        label: 'Last name',
        type: 'text',
        placeholder: 'Enter Last Name',
        error: 'Last Name is required',
        name: 'last_name',
        hint: null,
        required: true,
      },
      {
        label: 'Email',
        type: 'email',
        placeholder: 'Enter Email',
        error: 'Email is required',
        name: 'email',
        hint: "If you're affiliated with a university, use your .edu email",
        required: true,
      },
      {
        label: 'Receive emails about sim updates and events?',
        type: 'radio',
        placeholder: null,
        error: null,
        name: 'newsletter',
        hint: "We announce new features, webinars, and help content over email.  We won't share your info.",
        required: true,
      },
    ],
    buttonLabel:
      '<p class="p-0">By creating an account, you agree to our <span class="text-dms-primary cursor-pointer hover:underline"><a href="/user_agreement" target="_blank" rel="noreferrer noopener">terms and conditions</a></span></p>',
    buttonCopy: [
      {
        text: 'Next',
        type: 'accountPassword',
      },
    ],
  },
  accountPassword: {
    title: 'Create your password',
    formStep: 1,
    inputs: [
      {
        label: 'Password',
        type: 'password',
        placeholder: 'Enter Password',
        error: 'Password is required',
        name: 'password',
        hint: `<p class="p-0">Must contain:</p><ul class="list-disc list-inside ml-1.5"><li>8-12 characters</li><li>an uppercase letter</li><li>a lowercase letter</li><li>a number</li><li>a symbol(@!%*?&)</li></ul>`,
        required: true,
      },
      {
        label: 'Confirm password',
        type: 'password',
        placeholder: 'Enter Password',
        error: 'Password is required',
        name: 'confirmPassword',
        hint: null,
        required: true,
      },
    ],
    buttonLabel: null,
    buttonCopy: [
      {
        text: 'Next',
        type: 'orgType',
      },
    ],
  },
  orgType: {
    title: 'Do you work at a college or university?',
    formStep: 2,
    buttonLabel: null,
    buttonCopy: [
      {
        text: 'Yes',
        type: 'universityFlow',
      },
      {
        text: 'No',
        type: 'companyFlow',
      },
    ],
  },
  // NASPAA question removed — university users skip directly to universityInfo
  universityInfo: {
    title: 'Your organization',
    formStep: 4,
    inputs: [
      {
        label: 'What is the name of your university?',
        type: 'search',
        placeholder: null,
        error: null,
        name: 'university_name',
        hint: 'Start typing to search',
        required: true,
      },
      {
        label: 'Department or school',
        type: 'text',
        placeholder: 'Enter Department or School',
        error: null,
        name: 'department',
        hint: null,
        required: true,
      },
      {
        label: 'Your job title',
        type: 'text',
        placeholder: 'Enter Job Title',
        error: null,
        name: 'title',
        hint: null,
        required: false,
      },
      {
        label: 'Which of the following best describes you?',
        type: 'radio',
        placeholder: null,
        error: null,
        name: 'universityRole',
        hint: null,
        required: false,
      },
    ],
    buttonLabel: null,
    buttonCopy: [
      {
        text: 'Create account',
        type: 'submit',
      },
    ],
  },
  companyFlow: {
    formStep: 3,
    inputs: [
      {
        label: 'What industry do you work in?',
        type: 'multiButton',
        radialButtonCopy: [
          {
            text: 'Primary/elementary education',
            type: 'companyInfo',
          },
          {
            text: 'Secondary/high school education',
            type: 'companyInfo',
          },

          {
            text: 'Finance',
            type: 'companyInfo',
          },
          {
            text: 'Technology',
            type: 'companyInfo',
          },
          {
            text: 'Government',
            type: 'companyInfo',
          },
          {
            text: 'Other',
            type: 'companyInfo',
          },
        ],
        placeholder: null,
        error: null,
        name: 'industry',
        hint: null,
        required: 'true',
      },
    ],
    buttonLabel: null,
    buttonCopy: [
      {
        text: 'Next',
        type: 'companyInfo',
      },
    ],
  },
  companyInfo: {
    title: 'Tell us about organization',
    formStep: 4,
    inputs: [
      {
        label: 'What is the name of your organization?',
        type: 'text',
        placeholder: null,
        error: 'Organization Name is required',
        name: 'organization_name',
        hint: null,
        required: true,
      },
      {
        label: 'Department or group',
        type: 'text',
        placeholder: null,
        error: null,
        name: 'org_department',
        hint: null,
        required: false,
      },
      {
        label: 'Your job title',
        type: 'text',
        placeholder: null,
        error: null,
        name: 'org_title',
        hint: null,
        required: false,
      },
    ],
    buttonLabel: null,
    buttonCopy: [
      {
        text: 'Create account',
        type: 'submit',
      },
    ],
  },
  // naspaaSuccess removed — all users see orgSuccess
  orgSuccess: {
    title: 'Verify your email',
    successText: (userEmail) =>
      `<p class="pl-0">We’ve sent a verification email to <strong>${userEmail}</strong>. Select the link in the email to finish creating your account.</p><p class="pl-0">Don't see the email?  Check your junk or spam folders.</p>`,
    formStep: 5,
  },
};
